import { Sku } from "./Sku";

export class SkuDashboard {
    tiempoAire: Sku[];
    paquetes: Sku[];
    peajes: Sku[];
    servicios: Sku[];
    pines: Sku[];

    constructor({
        tiempoAire = [],
        paquetes = [],
        peajes = [],
        servicios = [],
        pines = []
    }) {
        this.tiempoAire = tiempoAire;
        this.paquetes = paquetes;
        this.peajes = peajes;
        this.servicios = servicios;
        this.pines = pines;
    }
}